import {
  REQUEST_USER_DATA,
  RECEIVE_USER_DATA,
  FINISH_USER_DATA_FETCHING,
  RECEIVE_USER_DATA_ERROR,
  CHANGE_USER_VIEW_PREFERENCE,
  SET_NO_ROUTE_ACCESS,
  DISCOUNT_CLUB_DATA,
  SET_NICKNAME,
} from '../actions/user';
import { SET_MOBILE_APP_BANNER_CLOSED } from 'apps/appBanner/actions/appBanner';
import { OR_SUBSCRIPTION_CANCELLATION_SUCCESS } from 'apps/ordersReserved/actions/management/orSettings';
import { SET_EMAIL } from 'apps/settings/actions/accountDetails/changeCredentials';
import SlotSubscriptionEligibility from 'apps/topNavigation/models/SlotSubscriptionEligibility';

export const initialState = {
  betaFeatures: [],
  features: [],
  customerDetails: null,
  customerNum: null,
  discountClub: null,
  eligibilityDetails: null,
  received: false,
  isFetching: false,
  mobileAppBanner: null,
  noRouteAccess: false,
  error: null,
};

const ACTIONS = {
  [SET_NO_ROUTE_ACCESS]: ({ state, action }) => ({ ...state, noRouteAccess: action.action || true }),
  [REQUEST_USER_DATA]: ({ state }) => ({ ...state, isFetching: true }),
  [RECEIVE_USER_DATA]: ({ state, action }) => {
    const { customerDetails } = action.user;
    return {
      ...state,
      received: true,
      error: null,
      customerNum: customerDetails ? customerDetails.customerNum : null,
      ...action.user,
    };
  },
  [FINISH_USER_DATA_FETCHING]: ({ state }) => ({ ...state, isFetching: false }),
  [SET_EMAIL]: ({ state, action }) => {
    const { customerDetails } = state;
    return {
      ...state,
      customerDetails: {
        ...customerDetails,
        email: action.email,
      },
    };
  },
  [SET_NICKNAME]: ({ state, action }) => {
    const { customerDetails } = state;
    return {
      ...state,
      customerDetails: {
        ...customerDetails,
        customerNickname: action.customerNickname,
      },
    };
  },
  [RECEIVE_USER_DATA_ERROR]: ({ action }) => ({ ...initialState, error: action.error, isFetching: false }),
  [CHANGE_USER_VIEW_PREFERENCE]: ({ state, action }) => ({ ...state, fopViewPreference: action.value }),
  [SET_MOBILE_APP_BANNER_CLOSED]: ({ state }) => ({
    ...state,
    mobileAppBanner: {
      eligibleForUsers: false,
    },
  }),
  [DISCOUNT_CLUB_DATA]: ({ state, action }) => ({ ...state, discountClub: action.data }),
  [OR_SUBSCRIPTION_CANCELLATION_SUCCESS]: ({ state }) => ({
    ...state,
    eligibilityDetails: {
      ...state.eligibilityDetails,
      slotSubscription: SlotSubscriptionEligibility.ELIGIBLE_NOT_SUBSCRIBED,
    },
  }),
};

export default function user(state = initialState, action) {
  return ACTIONS[action.type] ? ACTIONS[action.type]({ state, action }) : state;
}
